import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, StatusBannerBiData } from '../types';
import { getKbWidgetState, getRuntimeDataForBi } from '../utils';

export const logChatbotStatusBannerStatusBannerClicked: BiEventLogger<StatusBannerBiData> = async (
  state,
  data,
) => {
  const biData = selectBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotStatusBannerStatusBannerClicked({
    incident_name: data.incident_name,
    incident_severity: data.incident_severity,
    incident_state: data.incident_state,
    conversation_id: biData.conversationId,
    lang: locale,
    chatbot_view: contextBi?.chatbot_view,
    session_id: sessionId,
    kb_widget_state: getKbWidgetState(state),
    main_option_name: biData.mainOptionName,
    mapping_product: contextBi?.mapping_product,
    mapping_url: contextBi?.mapping_url,
    user_experience: contextBi?.user_experience,
    user_intent: undefined,
    local_time_zone: undefined,
    chatbot_state: undefined,
  });
};
